import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { apiInstance } from '../../axiosApi';

export const modulePermissionGet = createAsyncThunk(
  'permission/module-permission',
  async (params) => {
    return await apiInstance.get('/permission/module-permission', { params });
  }
);

export const allModulePermissionGet = createAsyncThunk(
  'permission/module-permission-all',
  async () => {
    return await apiInstance.get('/permission/module-permission');
  }
);

export const modulePermissionDelete = createAsyncThunk(
  'admin/module-permission-delete',
  async (id) => {
    return await apiInstance.delete(`/permission/${id}`);
  }
);

export const modulePermissionAdd = createAsyncThunk(
  'permission/module-permission-add',
  async (payload) => {
    return await apiInstance.post('/permission/module-permission', payload);
  }
);

export const modulePermissionUpdate = createAsyncThunk(
  'permission/module-permission-update',
  async (payload) => {
    const { id, ...rest } = payload;
    return await apiInstance.put(`/permission/${id}`, rest);
  }
);

const initialState = {
  modulePermissionList: null
};

const modulePermissionSlice = createSlice({
  name: 'modulePermission',
  initialState,
  reducers: {
    clearModulePermissionSlice: () => initialState
  },
  extraReducers: (builder) => {
    builder.addCase(modulePermissionGet.fulfilled, (state, action) => {
      state.modulePermissionList = action?.payload;
    });
  }
});

export default modulePermissionSlice.reducer;
export const { clearModulePermissionSlice } = modulePermissionSlice.actions;

export const selectModulePermissionList = (state) => state.modulePermission.modulePermissionList;
export const useModulePermissionList = () => {
  const modulePermissionList = useSelector(selectModulePermissionList);
  return useMemo(() => modulePermissionList, [modulePermissionList]);
};
